function Card({ title, value, icon, note = '', emphasis = false }) {
  return (
    <article
      className={[
        'rounded-2xl border bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md',
        emphasis ? 'border-red-200' : 'border-slate-200',
      ].join(' ')}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">{title}</p>
          <p className="mt-2 text-3xl font-bold text-slate-900">{value}</p>
          <p className="mt-2 text-xs text-slate-500">{note || ' '}</p>
        </div>
        <div
          className={[
            'rounded-xl border p-3',
            emphasis
              ? 'border-red-100 bg-red-50 text-red-600'
              : 'border-slate-200 bg-slate-100 text-slate-600',
          ].join(' ')}
        >
          {icon}
        </div>
      </div>
    </article>
  );
}

export default function PrestamosActivosKPICards({ estadisticas }) {
  const { 
    total_prestamos_activos = 0,
    casi_por_terminar = 0 
  } = estadisticas || {};

  return (
    <section className="mb-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Card 
        title="Total Préstamos Activos" 
        value={total_prestamos_activos}
        note="Clientes con crédito vigente"
        emphasis
        icon={
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      />
      
      <Card 
        title="Préstamos Por Terminar" 
        value={casi_por_terminar}
        note="Se acercan al cierre de cuotas"
        icon={
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        }
      />
    </section>
  );
}
